import React from 'react';
import Marketing from '../images/marketing.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'Customer Journey Analysis',
    description: 'Improve customer satisfaction with journey analysis. We evaluate touchpoints to optimize the overall customer experience and increase retention.',
  },
  {
    icon: <FaLock />,
    title: 'Feedback Collection & Analysis',
    description: 'Gather and analyze customer feedback to drive improvements. Our services help you understand customer sentiments and enhance service delivery.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Personalisation Tactics',
    description: 'Enhance engagement with personalization tactics. We tailor interactions and communications to meet individual customer needs and preferences.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Customer Support Improvement',
    description: 'Elevate customer support with targeted improvements. We implement strategies to enhance responsiveness, efficiency, and satisfaction.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Customer Success Report',
    description: 'Track and report on customer success metrics. Our reports provide insights into customer satisfaction, retention, and overall success.',
  },

];

const CustomerExperience = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={Marketing}
        alt="Marketing Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Customer Experience Enhancement</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
        <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert Marketing Services</h2>
        <p className="text-md text-black mb-6 px-12 text-left">
        Maximize efficiency, enhance security, and drive growth with our tailored Marketing Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic Marketing planning to meet your business needs.
        </p>
        
        <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
        </div>
      </section>

    </div>

    </div>
  )
}

export default CustomerExperience
